// product grid/list
function listgridJavascript() {
Array.from(document.querySelectorAll(".wblistgridbtn")).forEach(link => {
    link.addEventListener('click', function(event) {
        Array.from(document.querySelectorAll(".wblistgridbtn")).forEach(e => e.classList.remove('active'));
        this.classList.add('active');
        if(this.classList.contains('listv')){
            document.getElementById('product-grid').classList.add('product-list');
            document.getElementById('product-grid').classList.remove('product-grid');
        }else if(this.classList.contains('gridv')){
            document.getElementById('product-grid').classList.add('product-grid');
            document.getElementById('product-grid').classList.remove('product-list');
        }
    }); 
});
};
document.addEventListener("shopify:section:load", listgridJavascript);
listgridJavascript();

// on scroll play video
window.addEventListener('load', videoScroll);
window.addEventListener('scroll', videoScroll);
function videoScroll() {
  if ( document.querySelectorAll('video[autoplay]').length > 0) {
    var windowHeight = window.innerHeight, videoEl = document.querySelectorAll('video[autoplay]');
    for (var i = 0; i < videoEl.length; i++) {
      var thisVideoEl = videoEl[i],
          videoHeight = thisVideoEl.clientHeight,
          videoClientRect = thisVideoEl.getBoundingClientRect().top;
      if ( videoClientRect <= ( (windowHeight) - (videoHeight*.5) ) && videoClientRect >= ( 0 - ( videoHeight*.5 ) ) ) {
        thisVideoEl.play();
      } else {
        thisVideoEl.pause();
      }
    }
  } 
}
   
// CARD PRODUCT TIMER

/* Helper: only write when the node actually exists.
   Missing nodes used to throw and kill the whole interval tick. */
function wbSetText(root, selector, value) {
  var el = root.querySelector(selector);
  if (el) el.textContent = value;
}
function wbPad(n) { return n < 10 ? '0' + n : String(n); }

var WB_DAY = 1000 * 60 * 60 * 24, WB_HOUR = 1000 * 60 * 60, WB_MIN = 1000 * 60;

setInterval(productCardCountdown, 1000);
function productCardCountdown() {
  var countCardSections = document.querySelectorAll('.wbcard_countd');
  if (!countCardSections.length) return;
  countCardSections.forEach(function (countCardSection) {
    var countDownDate = new Date(countCardSection.getAttribute('data-date')).getTime();
    var distance = countDownDate - new Date().getTime();
    var expired = isNaN(countDownDate) || distance < 0;
    wbSetText(countCardSection, '.main_cardday .wb_cardday',       expired ? '00' : wbPad(Math.floor(distance / WB_DAY)));
    wbSetText(countCardSection, '.main_cardhour .wb_cardhour',     expired ? '00' : wbPad(Math.floor((distance % WB_DAY) / WB_HOUR)));
    wbSetText(countCardSection, '.main_cardminute .wb_cardminute', expired ? '00' : wbPad(Math.floor((distance % WB_HOUR) / WB_MIN)));
    wbSetText(countCardSection, '.main_cardsecond .wb_cardsecond', expired ? '00' : wbPad(Math.floor((distance % WB_MIN) / 1000)));
  });
}

setInterval(countDown, 1000);
function countDown() {
  var countdownSections = document.querySelectorAll('.countd_all');
  if (!countdownSections.length) return;
  countdownSections.forEach(function (countdownSection) {
    var raw = countdownSection.getAttribute('data-date');

    if (!raw) {
      wbSetText(countdownSection, '.main_cdays .wb_cdays', '00');
      wbSetText(countdownSection, '.main_chours .wb_chours', '00');
      wbSetText(countdownSection, '.main_cminutes .wb_cminutes', '00');
      wbSetText(countdownSection, '.main_cseconds .wb_cseconds', '00');
      return;
    }

    var countDownDate = new Date(raw).getTime();
    var distance = countDownDate - new Date().getTime();

    if (isNaN(countDownDate) || distance < 0) {
      countdownSection.style.display = 'none';
      var message = document.getElementById('countdownMessage');
      if (message) message.style.display = 'block';   /* guard: this null was the sitewide crash */
      return;
    }

    wbSetText(countdownSection, '.main_cdays .wb_cdays',       wbPad(Math.floor(distance / WB_DAY)));
    wbSetText(countdownSection, '.main_chours .wb_chours',     wbPad(Math.floor((distance % WB_DAY) / WB_HOUR)));
    wbSetText(countdownSection, '.main_cminutes .wb_cminutes', wbPad(Math.floor((distance % WB_HOUR) / WB_MIN)));
    wbSetText(countdownSection, '.main_cseconds .wb_cseconds', wbPad(Math.floor((distance % WB_MIN) / 1000)));
  });
}
